import { render, staticRenderFns } from "./SaveManager.vue?vue&type=template&id=c8c334a6&scoped=true&"
import script from "./SaveManager.vue?vue&type=script&lang=js&"
export * from "./SaveManager.vue?vue&type=script&lang=js&"
import style0 from "./SaveManager.vue?vue&type=style&index=0&id=c8c334a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8c334a6",
  null
  
)

export default component.exports